import { jsx as _jsx } from "react/jsx-runtime";
import { Listbox } from '@bluebeam/react-skyline-listbox';
import { useObjectRef } from '@react-aria/utils';
import { forwardRef } from 'react';
import { useListBox } from 'react-aria';
const DropdownListbox = forwardRef(({ children, state, style, ...props }, ref) => {
    const listboxRef = useObjectRef(ref);
    const { listBoxProps } = useListBox(props, state, listboxRef);
    return (_jsx(Listbox, { ref: listboxRef, ...listBoxProps, style: { ...listBoxProps.style, ...style }, children: children }));
});
export default DropdownListbox;
//# sourceMappingURL=DropdownListbox.js.map